import { schema } from 'normalizr';

export const earnerSchema = new schema.Entity('creditEarner');
export const claimSchema = new schema.Entity('claim', {
  creditEarner: earnerSchema,
});
export const resultsSchema = [claimSchema];
